"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Sep 07 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * CompetitorProductConverter
 *
 * @author RV
 */


var CompetitorProductBindingConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CompetitorProductBindingConverter, _DataObjectConverter_);

  function CompetitorProductBindingConverter() {
    _classCallCheck(this, CompetitorProductBindingConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorProductBindingConverter).apply(this, arguments));
  }

  return CompetitorProductBindingConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CompetitorProductBindingConverter = CompetitorProductBindingConverter;